import { ProtocolContentData } from "../../protocol";
export default class RouteMonitoringData extends ProtocolContentData {
    plannedCourseToWaypoint;
    distanceSinceFirstWaypoint;
    distanceToDestination;
    totalDistanceTraveledOverGround;
    totalDistanceTraveledThroughWater;
    timeToGoToDestination;
    routeChangeRemarks;
    constructor(plannedCourseToWaypoint, distanceSinceFirstWaypoint, distanceToDestination, totalDistanceTraveledOverGround, totalDistanceTraveledThroughWater, timeToGoToDestination, routeChangeRemarks) {
        super();
        this.plannedCourseToWaypoint = plannedCourseToWaypoint;
        this.distanceSinceFirstWaypoint = distanceSinceFirstWaypoint;
        this.distanceToDestination = distanceToDestination;
        this.totalDistanceTraveledOverGround = totalDistanceTraveledOverGround;
        this.totalDistanceTraveledThroughWater = totalDistanceTraveledThroughWater;
        this.timeToGoToDestination = timeToGoToDestination;
        this.routeChangeRemarks = routeChangeRemarks;
    }
}
//# sourceMappingURL=RouteMonitoringData.js.map